import * as React from 'react';
import { compose, pure } from 'recompose';
import classNames from 'classnames';
import { CSSProperties } from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import { Icon, Omit, Theme } from '@material-ui/core';

import { setProp } from '@style/theme/themeUtils';

export interface FontIconProps {
  iconName: string;
  color?: string;
  size?: number;
  top?: number;
  left?: number;
  onClick?: any;
  block?: boolean;
  fromMui?: boolean;
  marginLeft?: number;
  marginRight?: number;
  classes?: Partial<WithStyles<typeof styles>['classes']>;
  className?: string;
}

export interface FontIconPrivateProps extends WithStyles<typeof styles, true>, Omit<FontIconProps, 'classes'> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      // fontSize: theme.font.size.mediumBig,
      fontSize: 12,
      color: theme.palette.primary.dark,
      display: 'inline-block',
      position: 'relative',
      top: 0,
      left: 0,
      marginLeft: 0,
      marginRight: 0,
      transition: 'inherit',
    },
    muiIcon: {
      width: 20,
      height: 20,
    },
  });

const FontIcon: React.FC<FontIconPrivateProps> = (props) => {
  const { iconName, className, classes, fromMui, onClick } = props;

  let inlineStyles: CSSProperties = {};
  inlineStyles = setProp(inlineStyles, 'fontSize', props.size);
  inlineStyles = setProp(inlineStyles, 'color', props.color);
  inlineStyles = setProp(inlineStyles, 'display', props.block && 'block');
  inlineStyles = setProp(inlineStyles, 'top', props.top);
  inlineStyles = setProp(inlineStyles, 'left', props.left);
  inlineStyles = setProp(inlineStyles, 'marginLeft', props.marginLeft);
  inlineStyles = setProp(inlineStyles, 'cursor', props.onClick ? 'pointer' : 'inherit');
  inlineStyles = setProp(inlineStyles, 'marginRight', props.marginRight);

  return fromMui ? (
    <Icon style={inlineStyles} onClick={onClick} className={classNames(classes.root, classes.muiIcon, className)}>
      {iconName}
    </Icon>
  ) : (
    <span style={inlineStyles} onClick={onClick} className={classNames(classes.root, className, `icon-${iconName}`)} />
  );
};

const ComposedFontIcon = compose<FontIconPrivateProps, FontIconProps>(
  pure,
  withStyles(styles, { withTheme: true }),
)(FontIcon);
ComposedFontIcon.displayName = 'FontIcon';

export default ComposedFontIcon;
